import type {ReactElement} from 'react';
import React, {useEffect, useState} from 'react';
import type {ChangeEmailTemplatePanelProps} from '@Panels/change-email-template-panel';
import {useAppSelector} from '@/hooks';
import {MODALS_IDS} from '@Components/modal-container';
import useWindowSize from '@Hooks/useWindowSize';
import {MOBILE_MODAL_WIDTH_THRESHOLD, Modal} from '@Components/modal';
import {LazyPanel} from '@Components/lazy-panel';
import {PANEL_ID} from '@Modals/change-email-template-modal';

const CHANGE_EMAIL_TEMPLATE_MODAL_MAX_WIDTH_PX = 1100;
const CHANGE_EMAIL_TEMPLATE_MODAL_MAX_HEIGHT_PX = 800;

export type ChangeEmailTemplateModalProps = ChangeEmailTemplatePanelProps;

export default function ChangeEmailTemplateModal(): ReactElement<any> | null {
  const modalData = useAppSelector((state) => {
    return state.modals.modalsHashmap[MODALS_IDS.CHANGE_EMAIL_TEMPLATE_MODAL];
  });
  const isPanelLoading = useAppSelector((state) => {
    return state.lazyPanels.lazyPanelHashmap[PANEL_ID]?.isLoading ?? false;
  });
  const [height, setHeight] = useState<string>('');
  const [width, setWidth] = useState<string>('');

  const {windowWidth} = useWindowSize();

  const isMobileModal = (): boolean => {
    return windowWidth < MOBILE_MODAL_WIDTH_THRESHOLD;
  };

  useEffect(() => {
    if (isPanelLoading) {
      setHeight('700');
      setWidth(isMobileModal() ? '100%' : '1100');
    } else {
      setHeight('auto');
      setWidth(isMobileModal() ? '100%' : '100%');
    }
  }, [isPanelLoading]);

  const maxWidth = `${CHANGE_EMAIL_TEMPLATE_MODAL_MAX_WIDTH_PX}px`;
  const maxHeight = `${CHANGE_EMAIL_TEMPLATE_MODAL_MAX_HEIGHT_PX}px`;

  return (
    <Modal modalId={MODALS_IDS.CHANGE_EMAIL_TEMPLATE_MODAL} panelId={PANEL_ID} modalMaxWidth={maxWidth} modalWidth={width} modalHeight={height} modalMaxHeight={maxHeight}>
      <LazyPanel
        lazyPanelId={PANEL_ID}
        panelDirectoryName="change-email-template-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}
